import { type OverlayPlacement } from "@dropbox/dig-components/overlay";
import { Text } from "@dropbox/dig-components/typography";
import i18n from "@mirage/translations";
import classnames from "classnames";
import styles from "./DashTrial.module.css";
import { DashTrialCTA } from "./DashTrialCTA";
import { DashTrialCTAButtonVariant } from "./DashTrialCTA/DashTrialCTAButton";

type DashTrialIndicatorProps = {
  daysLeft: number;
  adminName?: string;
  variant?: DashTrialCTAButtonVariant;
  tooltipPlacement?: OverlayPlacement;
  tooltipVariant?: "withTitle" | "withoutTitle";
  classNames?: {
    container?: string;
    copy?: string;
  };
};

export const DashTrialIndicatorInner = ({
  daysLeft,
  adminName,
  variant = DashTrialCTAButtonVariant.PRIMARY,
  tooltipPlacement = "bottom-end",
  tooltipVariant = "withTitle",
  classNames,
}: DashTrialIndicatorProps) => {
  return (
    <div
      className={classnames(
        styles.dashTrialIndicatorContainer,
        classNames?.container,
      )}
    >
      <div className={styles.dashTrialIndicatorCopy}>
        <Text variant="label" size="small">
          {i18n.t("days_remaining", { count: daysLeft })}
        </Text>
      </div>
      <DashTrialCTA
        adminName={adminName}
        variant={variant}
        tooltipPlacement={tooltipPlacement}
        tooltipVariant={tooltipVariant}
      />
    </div>
  );
};
